var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDplay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.514047 0.459339C0.188203 0.822882 0 1.37838 0 2.10546V27.8938C0 28.6208 0.188203 29.1763 0.525283 29.5253L0.612362 29.6039L14.5675 15.1552V14.8324L0.601126 0.380814L0.514047 0.459339Z",
    fill: "url(#paint0_linear_39_798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2114 19.9859L14.5569 15.1668V14.8295L19.2114 10.0103L19.3125 10.0743L24.8182 13.3142C26.3941 14.2332 26.3941 15.7514 24.8182 16.6821L19.3125 19.922L19.2114 19.9859Z",
    fill: "url(#paint1_linear_39_798)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3125 19.922L14.5568 14.9981L0.514648 29.537C1.0287 30.107 1.89106 30.171 2.85455 29.6155L19.3125 19.922Z",
    fill: "url(#paint2_linear_39_798)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3125 10.0743L2.85455 0.395367C1.89106 -0.174669 1.02589 -0.096143 0.514648 0.473893L14.5568 14.9982L19.3125 10.0743Z",
    fill: "url(#paint3_linear_39_798)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2107 19.8173L2.86506 29.4323C1.95213 29.9761 1.13751 29.9383 0.612226 29.4439L0.525146 29.5341L0.612226 29.6126C1.13751 30.1041 1.95213 30.1448 2.86506 29.601L19.3231 19.922L19.2107 19.8173Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8178 16.5134L19.197 19.8173L19.2981 19.922L24.8038 16.6821C25.5931 16.2167 25.9808 15.606 25.9808 14.9981C25.933 15.5565 25.5313 16.0859 24.8178 16.5134Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85394 0.56405L24.8175 13.4829C25.531 13.8988 25.9327 14.4427 25.9945 14.9982C25.9945 14.3903 25.6068 13.7796 24.8175 13.3142L2.85394 0.395366C1.2781 -0.538213 0 0.241224 0 2.10547V2.27416C0 0.406999 1.2781 -0.357895 2.85394 0.56405Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_798",
    x1: 13.3157,
    y1: 1.82723,
    x2: -9.13791,
    y2: 7.60567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_798",
    x1: 26.8733,
    y1: 14.9982,
    x2: -0.382448,
    y2: 14.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_798",
    x1: 16.7266,
    y1: 17.6774,
    x2: -2.15601,
    y2: 48.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_798",
    x1: -3.02133,
    y1: -8.11825,
    x2: 5.40318,
    y2: 5.59117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplay);
export default __webpack_public_path__ + "static/media/dplay.906739ed2f48afe517c9c9794bd29e6d.svg";
export { ForwardRef as ReactComponent };